{
    "LicenceManagementPage_Title": "Licence Management",
    "LicenceManagementPage_Subtitle": "Manage device and user assignments for a selected telephony scope.",
    "LicenceManagementPage_Tile_Analytics": "CX Analytics",
    "LicenceManagementPage_Tile_Score": "CX Score",
    "LicenceManagementPage_Tile_Record": "CX Record",
    "LicenceManagementPage_Tile_Transcribe": "CX Transcribe",
    "LicenceManagementPage_Tile_Integration": "CX Integration",
    "LicenceManagementPage_Tile_Licences": "Licences",
    "LicenceManagementPage_Column_DeviceNumber": "Device",
    "LicenceManagementPage_Column_Username": "User name",
    "LicenceManagementPage_Column_Email": "Email",
    "LicenceManagementPage_Column_HasDevice": "Device",
    "LicenceManagementPage_Column_Agent": "Agent",
    "LicenceManagementPage_Column_WelcomeEmail": "Welcome Email",
    "LicenceManagementPage_Column_Licences": "Licences",
    "LicenceManagementPage_Column_Actions": "Actions",
    "LicenceManagementPage_Type_Device": "Device",
    "LicenceManagementPage_Type_User": "User",
    "LicenceManagementPage_Popup_TelSys": "Telephony server",
    "LicenceManagementPage_Popup_Partition": "Partition",
    "LicenceManagementPage_Popup_Device": "Device",
    "LicenceManagementPage_Popup_Username": "Username",
    "LicenceManagementPage_Popup_Email": "Email",
    "LicenceManagementPage_Popup_Close": "Close",
    "LicenceManagementPage_LicencePopup_Title": "Manage Product Licenses",
    "LicenceManagementPage_LicencePopup_Licence": "License",
    "LicenceManagementPage_LicencePopup_ScoreUserCalls": "Score User Calls",
    "LicenceManagementPage_LicencePopup_RecordUserCalls": "Record User Calls",
    "LicenceManagementPage_LicencePopup_IntegrationEnabled": "Enabled",
    "LicenceManagementPage_LicencePopup_CxiUser": "CXI User",
    "LicenceManagementPage_LicencePopup_CxiData": "CXI Data",
    "LicenceManagementPage_LicencePopup_On": "On",
    "LicenceManagementPage_LicencePopup_Off": "Off",
    "LicenceManagementPage_LicencePopup_Enabled": "Enabled",
    "LicenceManagementPage_LicencePopup_Disabled": "Disabled",
    "LicenceManagementPage_LicencePopup_EmailRequired": "Add an email address before saving license changes for this device.",
    "LicenceManagementPage_Email_AddTooltip": "Click to add email and create user",
    "LicenceManagementPage_EssentialsExtension": "Essentials (Extension)",
    "LicenceManagementPage_Empty": "Nothing found here",
    "LicenceManagementPage_WelcomeEmail_Title": "Resend welcome email to \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Confirm": "Would you like to resend the welcome email to \"{}\"?",
    "LicenceManagementPage_WelcomeEmail_Success": "Email was successfully sent to \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Fail": "There was an unexpected error when sending the email. Please try again.",
    "LicenceManagementPage_Licence_SaveFailed": "The user's current settings could not be read, so the licences were not saved. Please try again.",
    "LicenceManagementPage_Column_LicencesCount": "[{} Licenses]",
    "LicenceManagementPage_Tick_Save": "Save row changes",
    "LicenceManagementPage_Tick_InvalidEmail": "Enter a valid email address to create the user.",
    "LicenceManagementPage_Licence_ScoringEnabled": "Scoring Enabled",
    "LicenceManagementPage_Licence_RecordingEnabled": "Recording Enabled",
    "LicenceManagementPage_Licence_TranscribeEnabled": "Transcribe Enabled",
    "LicenceManagementPage_Licence_WithScoring": "{} + Scoring",
    "LicenceManagementPage_Licence_WithRecording": "{} + Recording",
    "LicenceManagementPage_Username_NoUserTooltip": "This will be used as the username when a new user is created",
    "LicenceManagementPage_BulkAssign_Button": "Bulk assign licences",
    "LicenceManagementPage_BulkAssign_Title": "Bulk assign licences",
    "LicenceManagementPage_BulkAssign_Step_System": "Telephony system",
    "LicenceManagementPage_BulkAssign_Step_Options": "Choose licence and options",
    "LicenceManagementPage_BulkAssign_Step_Users": "Select users",
    "LicenceManagementPage_BulkAssign_Cme": "CME",
    "LicenceManagementPage_BulkAssign_TelSys": "Telephony system",
    "LicenceManagementPage_BulkAssign_ChooseCmeFirst": "Choose the CME, then the telephony system.",
    "LicenceManagementPage_BulkAssign_ChooseTelSys": "Choose the telephony system to work on.",
    "LicenceManagementPage_BulkAssign_ChooseTelSysFirst": "Choose a telephony system first.",
    "LicenceManagementPage_BulkAssign_TelSysLoadFailed": "Couldn't load telephony systems: {}",
    "LicenceManagementPage_BulkAssign_CheckingType": "Checking system type...",
    "LicenceManagementPage_BulkAssign_Detected": "Detected from the page you're viewing",
    "LicenceManagementPage_BulkAssign_Profile_TeamsBusiness": "Microsoft Teams (Business)",
    "LicenceManagementPage_BulkAssign_Profile_TeamsLegacy": "Microsoft Teams (Legacy)",
    "LicenceManagementPage_BulkAssign_Profile_Wxc": "Webex Calling",
    "LicenceManagementPage_BulkAssign_Profile_BroadWorks": "BroadWorks",
    "LicenceManagementPage_BulkAssign_UnknownType": "Unknown type ({}) - using BroadWorks names",
    "LicenceManagementPage_BulkAssign_TypeReadFailed": "Couldn't read the system type ({}) - using BroadWorks names.",
    "LicenceManagementPage_BulkAssign_LoadUsers": "Load users",
    "LicenceManagementPage_BulkAssign_Loading": "Loading...",
    "LicenceManagementPage_BulkAssign_LoadingProgress": "Loading {} of {}...",
    "LicenceManagementPage_BulkAssign_Loaded": "{} entries loaded, {} unlicensed.",
    "LicenceManagementPage_BulkAssign_LoadedWithGroups": "{} entries loaded, {} unlicensed, {} groups.",
    "LicenceManagementPage_BulkAssign_GroupFailures": "({} devices' groups couldn't be read)",
    "LicenceManagementPage_BulkAssign_LoadingGroups": "Loading groups {} of {}...",
    "LicenceManagementPage_BulkAssign_LoadFailed": "Couldn't load users: {}",
    "LicenceManagementPage_BulkAssign_LoadFailedSession": "Couldn't load users: {} - are you still logged in?",
    "LicenceManagementPage_BulkAssign_Licence": "Licence to assign to selected users",
    "LicenceManagementPage_BulkAssign_WelcomeEmail": "Send welcome email to new users",
    "LicenceManagementPage_BulkAssign_Search": "Search name, email or number",
    "LicenceManagementPage_BulkAssign_Groups_All": "Groups: All",
    "LicenceManagementPage_BulkAssign_Groups_Label": "Groups",
    "LicenceManagementPage_BulkAssign_Groups_Loading": "Groups: loading...",
    "LicenceManagementPage_BulkAssign_Groups_One": "Group: {}",
    "LicenceManagementPage_BulkAssign_Groups_Many": "Groups: {} selected",
    "LicenceManagementPage_BulkAssign_Groups_Search": "Search groups",
    "LicenceManagementPage_BulkAssign_Groups_Security": "Security groups",
    "LicenceManagementPage_BulkAssign_Groups_Queues": "Call queues",
    "LicenceManagementPage_BulkAssign_Groups_NoMatch": "No groups match.",
    "LicenceManagementPage_BulkAssign_Groups_NoneLoaded": "No groups loaded.",
    "LicenceManagementPage_BulkAssign_Groups_CountAll": "Count = all users",
    "LicenceManagementPage_BulkAssign_Groups_CountUnlicensed": "Groups with unlicensed users only",
    "LicenceManagementPage_BulkAssign_Groups_Clear": "Clear",
    "LicenceManagementPage_BulkAssign_Groups_Done": "Done",
    "LicenceManagementPage_BulkAssign_ShowLicensed": "Show licensed users",
    "LicenceManagementPage_BulkAssign_SelectAll": "Select all shown",
    "LicenceManagementPage_BulkAssign_SelectRow": "Select {}",
    "LicenceManagementPage_BulkAssign_Column_Name": "Name",
    "LicenceManagementPage_BulkAssign_Column_Username": "Username / email",
    "LicenceManagementPage_BulkAssign_Column_Device": "Device ID",
    "LicenceManagementPage_BulkAssign_Column_Partition": "Partition",
    "LicenceManagementPage_BulkAssign_Column_Licence": "Licence type",
    "LicenceManagementPage_BulkAssign_Column_Status": "Status",
    "LicenceManagementPage_BulkAssign_EnterEmail": "Enter email",
    "LicenceManagementPage_BulkAssign_UserExists": "User already exists",
    "LicenceManagementPage_BulkAssign_NoLicence": "No licence assigned",
    "LicenceManagementPage_BulkAssign_NoLicenceShort": "None",
    "LicenceManagementPage_BulkAssign_Empty_NotLoaded": "Load users to get started.",
    "LicenceManagementPage_BulkAssign_Empty_NoMatch": "No unlicensed users match.",
    "LicenceManagementPage_BulkAssign_Empty_NoGroupMatch": "No unlicensed users in the selected groups.",
    "LicenceManagementPage_BulkAssign_Status_Ready": "Ready",
    "LicenceManagementPage_BulkAssign_Status_Licensed": "Licensed",
    "LicenceManagementPage_BulkAssign_Status_Waiting": "Waiting",
    "LicenceManagementPage_BulkAssign_Status_Working": "Working...",
    "LicenceManagementPage_BulkAssign_Status_Created": "Created - {}",
    "LicenceManagementPage_BulkAssign_Status_Updated": "Updated - {}",
    "LicenceManagementPage_BulkAssign_Status_Failed": "Failed",
    "LicenceManagementPage_BulkAssign_Status_NotRun": "Not run (stopped)",
    "LicenceManagementPage_BulkAssign_Blocker_Licensed": "Already licensed",
    "LicenceManagementPage_BulkAssign_Blocker_PendingDeletion": "Pending deletion",
    "LicenceManagementPage_BulkAssign_Blocker_NeedsEmail": "Needs an email address",
    "LicenceManagementPage_BulkAssign_Blocker_InvalidEmail": "Enter a valid email address",
    "LicenceManagementPage_BulkAssign_Blocker_NoAgent": "No agent - can't be {}",
    "LicenceManagementPage_BulkAssign_Blocker_NoDevice": "No device - needs a device",
    "LicenceManagementPage_BulkAssign_CreatedWarning": "Created, but CCS reported an error afterwards - check this user in CCS.",
    "LicenceManagementPage_BulkAssign_Error_Admin": "Admin user - remove their admin rights in CCS, then try again.",
    "LicenceManagementPage_BulkAssign_Error_Session": "Your session has expired or you're not allowed to do this - log in again and re-run.",
    "LicenceManagementPage_BulkAssign_Error_Unknown": "Unknown error",
    "LicenceManagementPage_BulkAssign_Meta_Http": "HTTP {}",
    "LicenceManagementPage_BulkAssign_Meta_Code": "code {}",
    "LicenceManagementPage_BulkAssign_NoneSelected": "No users selected",
    "LicenceManagementPage_BulkAssign_SelectedCount": "{} selected · {} {}",
    "LicenceManagementPage_BulkAssign_RunProgress": "{}/{} succeeded, {}/{} failed",
    "LicenceManagementPage_BulkAssign_Assign": "Assign licences to {}",
    "LicenceManagementPage_BulkAssign_Stop": "Stop",
    "LicenceManagementPage_BulkAssign_DownloadCsv": "Download results (CSV)",
    "LicenceManagementPage_BulkAssign_Close": "Close",
    "LicenceManagementPage_BulkAssign_Confirm_Title": "Assign {} licences?",
    "LicenceManagementPage_BulkAssign_Confirm_ByLicence": "{} × {}",
    "LicenceManagementPage_BulkAssign_Confirm_Users": "{} new users will be created, {} existing users updated.",
    "LicenceManagementPage_BulkAssign_Confirm_WelcomeOn": "Welcome email: ON - new users will be emailed",
    "LicenceManagementPage_BulkAssign_Confirm_WelcomeOff": "Welcome email: OFF - no emails will be sent",
    "LicenceManagementPage_BulkAssign_Confirm_Remaining": "{} {} licences remaining on this system.",
    "LicenceManagementPage_BulkAssign_Confirm_Shortfall": "Only {} {} licences are left for {} users, so {} of them will fail. Select fewer users or free up licences first.",
    "LicenceManagementPage_BulkAssign_Confirm_Capacity": "If you run out of licences, the remaining users will fail and be listed in the results.",
    "LicenceManagementPage_BulkAssign_Confirm_Cancel": "Cancel",
    "LicenceManagementPage_BulkAssign_Confirm_AssignNow": "Assign now",
    "LicenceManagementPage_BulkAssign_Summary_DoneTitle": "Finished",
    "LicenceManagementPage_BulkAssign_Summary_DoneResult": "{} succeeded, {} failed.",
    "LicenceManagementPage_BulkAssign_Summary_Stopped": "The run was stopped early.",
    "LicenceManagementPage_BulkAssign_Summary_Ok": "OK",
    "LicenceManagementPage_BulkAssign_Csv_Name": "Name",
    "LicenceManagementPage_BulkAssign_Csv_Username": "Username",
    "LicenceManagementPage_BulkAssign_Csv_Device": "Device number",
    "LicenceManagementPage_BulkAssign_Csv_Agent": "Agent number",
    "LicenceManagementPage_BulkAssign_Csv_Partition": "Partition",
    "LicenceManagementPage_BulkAssign_Csv_Licence": "Licence",
    "LicenceManagementPage_BulkAssign_Csv_Action": "Action",
    "LicenceManagementPage_BulkAssign_Csv_Result": "Result",
    "LicenceManagementPage_BulkAssign_Action_Create": "Create",
    "LicenceManagementPage_BulkAssign_Action_Update": "Update",
    "NAME": "LicenceManagementPageLanguage"
}
